export const LEAD_STATUSES = [
  "New",
  "Reviewed",
  "Contacted",
  "Replied",
  "Interested",
  "Not Interested",
  "Converted",
  "Do Not Contact",
];

export const CAMPAIGN_STATUSES = ["Draft", "Active", "Paused", "Completed"];

export const ICP_TEMPLATES = [
  {
    id: "freelance-designers",
    name: "Freelance designers",
    segment: "Freelancers",
    industry: "Design",
    businessType: "Freelancer",
    keywords: "freelance designer, brand designer, graphic designer",
    painPoint: "Creating polished quotations and tracking client invoices manually",
  },
  {
    id: "marketing-freelancers",
    name: "Marketing freelancers",
    segment: "Freelancers",
    industry: "Marketing",
    businessType: "Freelancer",
    keywords: "marketing consultant, social media freelancer, growth marketer",
    painPoint: "Sending proposals, estimates, and recurring client invoices",
  },
  {
    id: "web-agencies",
    name: "Web development agencies",
    segment: "Agencies",
    industry: "Web Development",
    businessType: "Agency",
    keywords: "web agency, software studio, website development",
    painPoint: "Managing project quotations, milestone billing, and invoices",
  },
  {
    id: "interior-designers",
    name: "Interior designers",
    segment: "Creative services",
    industry: "Interior Design",
    businessType: "Small Business",
    keywords: "interior studio, interior consultant, space designer",
    painPoint: "Preparing itemized estimates and branded client quotations",
  },
  {
    id: "consultants",
    name: "Consultants",
    segment: "Consultants",
    industry: "Consulting",
    businessType: "Consultant",
    keywords: "independent consultant, business advisor, strategy consultant",
    painPoint: "Turning proposals into invoices without duplicating work",
  },
  {
    id: "photographers",
    name: "Photographers",
    segment: "Creative services",
    industry: "Photography",
    businessType: "Freelancer",
    keywords: "event photographer, wedding photographer, photo studio",
    painPoint: "Quoting packages, collecting deposits, and billing clients",
  },
  {
    id: "event-planners",
    name: "Event planners",
    segment: "Service businesses",
    industry: "Events",
    businessType: "Small Business",
    keywords: "event planner, wedding planner, event agency",
    painPoint: "Managing changing estimates and vendor-based quotations",
  },
  {
    id: "contractors",
    name: "Small contractors",
    segment: "Service businesses",
    industry: "Contracting",
    businessType: "Small Business",
    keywords: "contractor, renovation services, installation business",
    painPoint: "Building detailed estimates and following up on unpaid invoices",
  },
  {
    id: "tax-legal",
    name: "Tax / legal consultants",
    segment: "Professional services",
    industry: "Tax & Legal",
    businessType: "Consultant",
    keywords: "tax consultant, legal advisor, compliance consultant",
    painPoint: "Billing retainers and one-off professional services consistently",
  },
  {
    id: "repair-services",
    name: "Repair / service businesses",
    segment: "Local services",
    industry: "Repair Services",
    businessType: "Small Business",
    keywords: "repair service, maintenance company, local service business",
    painPoint: "Creating quick estimates on-site and tracking customer billing",
  },
];

export const DEFAULT_LINKEDIN_TEMPLATES = [
  {
    id: "li-freelancer",
    channel: "linkedin",
    name: "Soft intro for freelancer",
    subject: "",
    body: "Hi {{firstName}}, I came across your work in {{industry}}. I’m building {{myProductName}}, a simple way for independent professionals to create polished quotations and invoices without wrestling with spreadsheets. Thought it might be relevant to how you manage client work. Happy to share it if useful.",
  },
  {
    id: "li-small-business",
    channel: "linkedin",
    name: "Small business quotation pain point",
    subject: "",
    body: "Hi {{firstName}}, quick question: how does {{businessName}} currently handle quotations and invoices? {{myProductName}} helps small service businesses create professional documents and keep client billing organized. I’d be glad to send a quick overview.",
  },
  {
    id: "li-agency",
    channel: "linkedin",
    name: "Agency proposal / invoice workflow",
    subject: "",
    body: "Hi {{firstName}}, I noticed {{businessName}} works in {{industry}}. We built {{myProductName}} to make the proposal-to-quotation-to-invoice workflow lighter for agencies. No complex setup, just a polished workflow for client billing. Would this be useful for your team?",
  },
  {
    id: "li-followup",
    channel: "linkedin",
    name: "Follow-up message",
    subject: "",
    body: "Hi {{firstName}}, just following up in case simplifying quotations and client invoices is on your list. {{myProductName}} is designed for service businesses that want a clean, practical workflow. No pressure at all; happy to share details if the timing is right.",
  },
];

export const DEFAULT_EMAIL_TEMPLATES = [
  {
    id: "email-freelancer",
    channel: "email",
    name: "Freelancer email",
    subject: "A simpler quotation workflow for {{businessName}}",
    body: "Hi {{firstName}},\n\nI found your work in {{industry}} and thought this could be relevant. {{myProductName}} helps freelancers create polished quotations and invoices, keep client details organized, and spend less time on manual billing.\n\nIf {{painPoint}} sounds familiar, I’d be happy to share a quick overview.\n\nBest,\n{{senderName}}",
  },
  {
    id: "email-small-business",
    channel: "email",
    name: "Small business email",
    subject: "Professional quotes and invoices, without the admin drag",
    body: "Hi {{firstName}},\n\nHow does {{businessName}} currently manage estimates, quotations, and invoices? {{myProductName}} is a lightweight tool built for service businesses that want professional documents and a cleaner billing workflow.\n\nWould a short overview be useful?\n\nBest,\n{{senderName}}",
  },
  {
    id: "email-agency",
    channel: "email",
    name: "Agency email",
    subject: "A cleaner quote-to-invoice flow for {{businessName}}",
    body: "Hi {{firstName}},\n\nAgencies often lose time recreating project details across proposals, quotations, and invoices. {{myProductName}} is designed to make that workflow faster and more consistent.\n\nI noticed {{businessName}} works in {{industry}} and thought it may be a good fit. Happy to send a concise walkthrough.\n\nBest,\n{{senderName}}",
  },
  {
    id: "email-followup",
    channel: "email",
    name: "Follow-up email",
    subject: "Following up: {{myProductName}}",
    body: "Hi {{firstName}},\n\nJust bringing this back to the top of your inbox. If creating quotations and managing client invoices is still more manual than it should be, {{myProductName}} may help.\n\nNo pressure; I’m happy to share details whenever useful.\n\nBest,\n{{senderName}}",
  },
];

const baseLeads = [
  {
    id: "lead-1",
    firstName: "Maya",
    lastName: "Kapoor",
    fullName: "Maya Kapoor",
    businessName: "Maya K Studio",
    role: "Freelance Brand Designer",
    industry: "Design",
    businessType: "Freelancer",
    country: "India",
    state: "Maharashtra",
    city: "Mumbai",
    linkedinUrl: "https://www.linkedin.com/in/maya-kapoor",
    websiteUrl: "https://example.com/mayakstudio",
    email: "maya@example.com",
    phone: "",
    leadSource: "Manual research",
    notes: "Uses spreadsheets for client billing.",
    painPoint: "Creating quotation and invoice documents manually",
    status: "Interested",
    lastContacted: "2026-06-04",
    followUpDate: "2026-06-11",
    createdAt: "2026-05-29T10:00:00.000Z",
  },
  {
    id: "lead-2",
    firstName: "Daniel",
    lastName: "Brooks",
    fullName: "Daniel Brooks",
    businessName: "Northline Web Co.",
    role: "Co-founder & Director",
    industry: "Web Development",
    businessType: "Agency",
    country: "United Kingdom",
    state: "England",
    city: "Manchester",
    linkedinUrl: "https://www.linkedin.com/in/daniel-brooks",
    websiteUrl: "https://example.com/northline",
    email: "daniel@example.com",
    phone: "+44 7700 900123",
    leadSource: "Referral",
    notes: "Small agency with milestone billing.",
    painPoint: "Proposal to invoice workflow is duplicated",
    status: "Replied",
    lastContacted: "2026-06-07",
    followUpDate: "2026-06-10",
    createdAt: "2026-05-31T11:30:00.000Z",
  },
  {
    id: "lead-3",
    firstName: "Aarav",
    lastName: "Mehta",
    fullName: "Aarav Mehta",
    businessName: "Form & Function Interiors",
    role: "Owner",
    industry: "Interior Design",
    businessType: "Small Business",
    country: "India",
    state: "Karnataka",
    city: "Bengaluru",
    linkedinUrl: "",
    websiteUrl: "https://example.com/formfunction",
    email: "aarav@example.com",
    phone: "",
    leadSource: "Trade directory",
    notes: "Quotes change often during projects.",
    painPoint: "Needs itemized estimates and revision tracking",
    status: "Contacted",
    lastContacted: "2026-06-06",
    followUpDate: "2026-06-13",
    createdAt: "2026-06-01T09:15:00.000Z",
  },
  {
    id: "lead-4",
    firstName: "Leah",
    lastName: "Morgan",
    fullName: "Leah Morgan",
    businessName: "Signal Growth",
    role: "Marketing Consultant",
    industry: "Marketing",
    businessType: "Consultant",
    country: "United States",
    state: "Texas",
    city: "Austin",
    linkedinUrl: "https://www.linkedin.com/in/leah-morgan",
    websiteUrl: "https://example.com/signalgrowth",
    email: "",
    phone: "",
    leadSource: "Conference list",
    notes: "Works with five to eight retainer clients.",
    painPoint: "Recurring client billing and proposals",
    status: "Reviewed",
    lastContacted: "",
    followUpDate: "",
    createdAt: "2026-06-02T14:00:00.000Z",
  },
  {
    id: "lead-5",
    firstName: "Noah",
    lastName: "Williams",
    fullName: "Noah Williams",
    businessName: "Noah W. Photography",
    role: "Photographer",
    industry: "Photography",
    businessType: "Freelancer",
    country: "Australia",
    state: "Victoria",
    city: "Melbourne",
    linkedinUrl: "",
    websiteUrl: "https://example.com/noahphoto",
    email: "hello@example.com",
    phone: "",
    leadSource: "Website search",
    notes: "Offers weddings and corporate packages.",
    painPoint: "Package estimates and deposit invoices",
    status: "New",
    lastContacted: "",
    followUpDate: "",
    createdAt: "2026-06-04T08:45:00.000Z",
  },
  {
    id: "lead-6",
    firstName: "Priya",
    lastName: "Shah",
    fullName: "Priya Shah",
    businessName: "PS Tax Advisory",
    role: "Tax Consultant",
    industry: "Tax & Legal",
    businessType: "Consultant",
    country: "India",
    state: "Gujarat",
    city: "Ahmedabad",
    linkedinUrl: "https://www.linkedin.com/in/priya-shah",
    websiteUrl: "",
    email: "priya@example.com",
    phone: "",
    leadSource: "Professional directory",
    notes: "Solo practice.",
    painPoint: "Manual billing for one-off advisory work",
    status: "Converted",
    lastContacted: "2026-06-01",
    followUpDate: "",
    createdAt: "2026-05-22T12:00:00.000Z",
  },
];

export const DEFAULT_SETTINGS = {
  productName: "Qyrova",
  userName: "",
  senderName: "Qyrova Team",
  senderEmail: "",
  websiteUrl: "",
  defaultCountry: "India",
  outreachTone: "Warm and professional",
  targetCountries: ["India", "United States", "United Kingdom", "Australia"],
};

export const INITIAL_DATA = {
  leads: baseLeads,
  campaigns: [
    {
      id: "campaign-1",
      name: "Independent creatives",
      targetSegment: "Freelancers",
      country: "India",
      industry: "Design",
      templateId: "li-freelancer",
      leadIds: ["lead-1", "lead-5"],
      status: "Active",
      createdAt: "2026-06-01T10:00:00.000Z",
    },
    {
      id: "campaign-2",
      name: "Agency workflow",
      targetSegment: "Agencies",
      country: "United Kingdom",
      industry: "Web Development",
      templateId: "email-agency",
      leadIds: ["lead-2"],
      status: "Draft",
      createdAt: "2026-06-06T10:00:00.000Z",
    },
  ],
  templates: [...DEFAULT_LINKEDIN_TEMPLATES, ...DEFAULT_EMAIL_TEMPLATES],
  settings: DEFAULT_SETTINGS,
  integrations: {},
  leadBuilder: {},
};
